export default __webpack_public_path__ + "static/media/keerthanar.c32d5808.jpg";